import { useCallback, useState } from 'react';

// Form state + "next step" dispatch shared by the resource wizards.
// `savers` maps a step name to a (values, data) function persisting that step.
export default function useWizardFlow({ steps, step, setStep, initialData, savers }) {
  const [formData, setFormData] = useState(initialData);

  const updateField = useCallback(
    (field, value) => setFormData((prev) => ({ ...prev, [field]: value })),
    []
  );

  const handleNext = useCallback(
    (data = {}) => {
      const values = { ...formData, ...data };
      setFormData(values);

      const save = savers[step];
      if (save) save(values, data);

      const index = steps.indexOf(step);
      if (index >= 0 && index < steps.length - 1) setStep(steps[index + 1]);
    },
    [formData, savers, step, steps, setStep]
  );

  return { formData, updateField, handleNext };
}
